"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rawTheme = exports["default"] = void 0;
var _styles = require("@mui/material/styles");
var rawTheme = {
  palette: {
    primary: {
      light: '#9B90F5',
      main: '#6453E7',
      dark: '#3E2E92',
      contrastText: '#FFFFFF'
    },
    secondary: {
      light: '#A5E0D9',
      main: '#5DCABC',
      dark: '#57AAA1',
      contrastText: '#FFFFFF'
    },
    lightGrey: {
      light: '#F7F7FA',
      main: '#EFEFF2',
      dark: '#D1D1D5'
    },
    darkGrey: {
      light: '#75757A',
      main: '#5B5B5C',
      dark: '#212027'
    },
    red: {
      light: '#FCD4D8',
      main: '#F23D4F',
      dark: '#C73241'
    },
    green: {
      light: '#DAF8EF',
      main: '#2ECC9C',
      dark: '#26A780'
    },
    chickenYellow: {
      light: '#FFDA6F',
      main: '#F8C633',
      dark: '#C7990F'
    },
    yellow: {
      light: '#FEF3D2',
      main: '#F8C633',
      dark: '#F4AC33'
    },
    background: {
      "default": '#FFFFFF',
      secondary: '#F7F7FA',
      tertiary: '#F3F3F7',
      light: '#F9F7FA',
      backdrop: '#272734'
    }
  },
  customShadows: {
    "default": '0 3px 10px rgba(0, 0, 0, 0.16)',
    upwards: '0 -3px 10px rgba(0, 0, 0, 0.16)',
    small: '0 3px 6px rgba(0, 0, 0, 0.16)',
    upwardsSmall: '0 -3px 6px rgba(0, 0, 0, 0.16)'
  },
  typography: {
    fontFamily: "'Lato', sans-serif",
    h1: {
      color: '#555555',
      fontSize: 24,
      fontWeight: 'bold',
      lineHeight: 1.083,
      marginBottom: 32
    },
    h2: {
      color: '#555555',
      fontSize: 20,
      fontWeight: 'bold',
      lineHeight: 1.083,
      marginBottom: 32
    },
    h3: {
      color: '#555555',
      fontSize: 16,
      fontWeight: 'bold',
      lineHeight: 1.083,
      marginBottom: 32
    },
    h4: {
      color: '#555555',
      fontSize: 16,
      fontWeight: 'normal',
      lineHeight: 1.083,
      marginBottom: 32
    },
    h5: {
      color: '#555555',
      fontSize: 14,
      fontWeight: 'normal',
      lineHeight: 1.083,
      marginBottom: 32
    },
    h6: {
      color: '#736A73',
      fontSize: 14,
      fontWeight: 'normal',
      lineHeight: 1.083,
      marginBottom: 32
    },
    subtitle1: {
      fontSize: 20,
      lineHeight: 1.2
    },
    subtitle2: {
      fontSize: 16,
      lineHeight: 1.375
    },
    body1: {
      fontSize: 14,
      lineHeight: 1.429
    },
    caption: {
      fontSize: 12,
      lineHeight: 1.333
    },
    button: {
      fontSize: 16
    },
    buttonSmall: {
      fontSize: 13
    }
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 375,
      md: 768,
      lg: 1024
    }
  },
  width: {
    sidebar: 286
  },
  zIndex: {
    sidebar: 1000
  }
};
exports.rawTheme = rawTheme;
var eventtiaTheme = (0, _styles.createTheme)(rawTheme);
var _default = eventtiaTheme;
exports["default"] = _default;